import { useState } from "react";
import Filters from "./filters";
import Table from "./table";

const PodDeliveryReport = () => {
  const [filters, setFilters] = useState(null);

  return (
    <>
      <div className="app-content-header">
        <div style={{ width: "100%", padding: "12px 24px" }}>
          <Filters onChange={setFilters} />
        </div>
      </div>
      <div className="nav-page-content">
        {filters ? (
          <Table filters={filters} />
        ) : (
          <div>
            Tahsilatlı gönderi raporunu görüntüleyebilmek için lütfen üst
            bölümden tarih aralığı seçiniz.
          </div>
        )}
      </div>
    </>
  );
};

export default PodDeliveryReport;
